// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionSteps_SaveServiceStepsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for POST /so/production_steps/save_service_steps
 *
 * Replaces all step assignments for a service. Wire shape:
 * `{ count, steps, reordered }`. Failure paths use $this->sendError('...').
 *
 * `steps` is the list AS STORED — the backend revalidates the terminal-block
 * rule, so a payload with a terminal step in the middle comes back normalized
 * rather than rejected. `reordered` is true exactly when that happened, which
 * is the client's cue to tell the user their flow was rearranged.
 */
import type { ProductionSteps_SavedStepRow } from './ProductionSteps_SavedStepRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ProductionSteps_SaveServiceStepsResponseDados {
count: number
steps: ProductionSteps_SavedStepRow[]
reordered: boolean
}

export type ProductionSteps_SaveServiceStepsResponse = ApiResponse<ProductionSteps_SaveServiceStepsResponseDados>;

registerResponseContract('ProductionSteps_SaveServiceStepsResponse', {
  count:     { type: 'number',  required: true },
  steps: {
    type: 'array',
    required: true,
    items: {
      production_step_id: { type: 'number',  required: true },
      is_terminal:        { type: 'number',  required: false },
      order:              { type: 'number',  required: false },
    },
  },
  reordered: { type: 'boolean', required: true },
})
